module.exports = __webpack_public_path__ + "img/1557614088326029313.ea1e7aeb.png";